function variantSelector() {
  document.querySelectorAll('.swatch-element input[type="radio"], .tab-variant input[type="radio"]').forEach(function (input) {
    input.addEventListener('change', function (event) {
      const variantId = event.target.getAttribute('data-variant');
      const productHandle = event.target.getAttribute('data-product-handle');
      const variantImg = event.target.getAttribute('data-image');
      const variantSellingPlansSize = event.target.getAttribute('data-selling-plans-size');
      const variantPrice = event.target.getAttribute('data-price');
      switchVariants(productHandle, variantId, variantSellingPlansSize);
      updateAddBarImage(variantImg);
      updateAddBarPrice(variantPrice);
    });
  });
}

document.addEventListener('DOMContentLoaded', variantSelector);


function switchVariants(productHandle, variantId, variantSellingPlansSize) {
  fetch(`/products/${productHandle}?variant=${variantId}&view=product`)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.text();
    })
    .then(html => {

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newProductInfo = doc.querySelector('#product-main');
      const currentProductInfo = document.querySelector('#product-main');

      if (newProductInfo && currentProductInfo) {
        currentProductInfo.replaceWith(newProductInfo.cloneNode(true));

        highlightMayQuotes();
        handleQuoteClick();
        reattachVariantSelectorListeners();
        attachProductThumbnailListeners();
        reinitializeSlickAndPlyr();
        clipVariantSelectorLabels(); 
        handlePdpVideoPlayback();
        window.PRIVE_WIDGET.PriveWidget.init();

        if (variantSellingPlansSize > 0) {
          observePriveWidget();
        }
        window.history.replaceState({}, '', `${window.location.pathname}?variant=${variantId}`);
      } else {
      }
    })
    .catch(() => {});
}

function updateVariantUrl(event) {
  const selectedOption = event.target.selectedOptions[0];
  const variantId = selectedOption.getAttribute('data-variant');
  window.history.replaceState({}, '', `${window.location.pathname}?variant=${variantId}`);
}

document.querySelectorAll('.single-option-selector').forEach(select => {
  select.addEventListener('change', updateVariantUrl);
});

function reinitializeSlickAndPlyr() {
  const productCarousel = document.querySelector('.product-carousel');

  if (productCarousel) {
    $(productCarousel).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      infinite: true,
      adaptiveHeight: true,
      draggable: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            dots: true,
            arrows: true,
          }
        }
      ]
    });

    const plyrElements = document.querySelectorAll('.plyr-video');
    if (plyrElements.length > 0) {
      Plyr.setup(plyrElements, {
        controls: ["play-large", "play", "progress", "current-time", "mute"],
        ratio: '1:1'
      });
    }

    setTimeout(() => {
      productCarousel.style.display = 'block';
      $(productCarousel).slick('refresh');
    }, 100);
  } else {
    console.warn('.product-carousel element not found.');
  }
}

function updateAddBarImage(variantImg) {
  const barImg = document.querySelector('.left-image img');
  barImg.src = "/cdn/shop/" + variantImg;
}

function updateAddBarPrice(variantPrice) {
  const priceElement = document.querySelector('[data-add-to-cart-text]');

  if (priceElement) {
    let buttonText = priceElement.textContent.replace(/\|\s*\$\d+/, '').trim();
    priceElement.textContent = `${buttonText} | ${variantPrice}`;
  }
}  

function highlightMayQuotes() {
  document.querySelectorAll('p').forEach(p => {
    const text = p.textContent.replace(/\s+/g, ' ').trim();
    if (text.startsWith('“')) {
      p.classList.add('product-description-quote');
    }
  });
}


function jumpToTab(tabNum) {
  const isMobile = window.innerWidth <= 768;
  const tabId = isMobile ? `tab${tabNum}mobile` : `tab${tabNum}`;
  const tabTrigger = document.getElementById(tabId);
  const offset = isMobile ? 150 : 200;

  if (tabTrigger) {
    if (!isMobile) {
      document.querySelectorAll('.pdp-tabs__heading').forEach(el => el.classList.remove('active'));
      tabTrigger.classList.add('active');

      const tabContentId = tabTrigger.getAttribute('href');
      const tabContent = document.querySelector(tabContentId);
      document.querySelectorAll('.pdp-tab').forEach(tab => tab.style.display = 'none');

      if (tabContent) {
        tabContent.style.display = 'block';
        setTimeout(() => {
          const position = tabContent.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top: position, behavior: 'smooth' });
        }, 100);
      }
    } else {
      document.querySelectorAll('.pdp-accordion__item').forEach(item => item.classList.remove('active'));
      document.querySelectorAll('.pdp-accordion__content').forEach(content => content.style.display = 'none');
      tabTrigger.classList.add('active');

      const targetAccordionContent = tabTrigger.querySelector('.pdp-accordion__content');
      if (targetAccordionContent) targetAccordionContent.style.display = 'block';

      const position = tabTrigger.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: position, behavior: 'smooth' });
    }
  } else {
    console.warn(`jumpToTab: tabTrigger not found for tab${tabNum}`);
  }
}

function handleQuoteClick() {
  document.querySelectorAll('.product-description-quote a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      const tabNum = this.getAttribute('href').replace('#tab', '');
      jumpToTab(tabNum);
    });
  });
}

function handleAnchorUrl() {
  if (window.location.hash === "#howtouse") {
    setTimeout(() => {
      requestAnimationFrame(() => {
        jumpToTab("2");
        history.replaceState(null, '', '#howtouse');
      });
    }, 250);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  highlightMayQuotes();
  handleQuoteClick();
  handleAnchorUrl();
});

function reattachVariantSelectorListeners() {
  document.querySelectorAll('.swatch-element input[type="radio"], .tab-variant input[type="radio"]').forEach(function (input) {
    input.addEventListener('change', function (event) {
      const variantId = event.target.getAttribute('data-variant');
      const productHandle = event.target.getAttribute('data-product-handle');
      const variantImg = event.target.getAttribute('data-image');
      const variantSellingPlansSize = event.target.getAttribute('data-selling-plans-size');
      const variantPrice = event.target.getAttribute('data-price');
      switchVariants(productHandle, variantId, variantSellingPlansSize);
      updateAddBarImage(variantImg);
      updateAddBarPrice(variantPrice);
    });
  });
}

function attachProductThumbnailListeners() {
  $('.product-thumb__link').off('click').on('click', function (e) {
    e.preventDefault();
    const idx = $(this).data('thumb-index');
    $('.product-thumb__link').removeClass('active');
    $(this).addClass('active');
    wick.goToSlide('.product-carousel', idx);
    return false;
  });
}


function moveAfterpayIntoPriveWidget() {
  const afterpayElement = document.querySelector('.visually-hidden .wick-afterpay');

  if (!afterpayElement) {
    console.warn('No Afterpay element found inside a visually-hidden container.');
    return;
  }


  const activePriveBox = document.querySelector('.prive_type_box_active.firstRank') || document.querySelector('#one');

  if (!activePriveBox) {
    console.warn('Active Prive widget container not found.');
    return;
  }


  const priveLabel = activePriveBox.querySelector('label.prive_label');

  if (!priveLabel) {
    console.warn('Prive widget label not found.');
    return;
  }


  priveLabel.appendChild(afterpayElement);
  afterpayElement.classList.remove('ge-hide');

  afterpayElement.style.marginLeft = "26px";
  afterpayElement.style.color = "#58595B";


  const afterpayLink = afterpayElement.querySelector('.wick-afterpay-link');
  if (afterpayLink) {
    afterpayLink.addEventListener('click', (event) => {
      event.stopPropagation();
    });
  }
}

function observePriveWidget() {
  const observer = new MutationObserver((mutationsList, observer) => {
    mutationsList.forEach(mutation => {
      if (mutation.type === 'childList' || mutation.type === 'attributes') {
        const activePriveBox = document.querySelector('.prive_type_box_active.firstRank') || document.querySelector('#one');
        if (activePriveBox) {
          moveAfterpayIntoPriveWidget();
          observer.disconnect();
        }
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true, attributes: true });
}

document.addEventListener("DOMContentLoaded", observePriveWidget);

function clipVariantSelectorLabels() {
  const labels = document.querySelectorAll('.swatch-element label');

  if (window.innerWidth <= 1400) {
    labels.forEach(function (label) {
      const originalText = label.getAttribute('data-original-text') || label.textContent.trim();

      if (originalText.toLowerCase().includes("3")) {
        return;
      }

      label.setAttribute('data-original-text', originalText);

      let clippedText = originalText;

      clippedText = clippedText.replace(/\s*\(.*?\)\s*/g, '').trim();

      label.textContent = clippedText;
    });
  } else {
    labels.forEach(function (label) {
      const originalText = label.getAttribute('data-original-text');
      if (originalText) {
        label.textContent = originalText;
      }
    });
  }
}

document.addEventListener("DOMContentLoaded", clipVariantSelectorLabels);
window.addEventListener("resize", clipVariantSelectorLabels);

function toggleBundleIngredients(tabIndex) {
  const allTabContentTargets = document.querySelectorAll('[data-tab-content-target]');
  const allTabContentImagesTargets = document.querySelectorAll('[data-tab-content-images-target]');

  allTabContentTargets.forEach((content) => {
    content.classList.add('hide');
    content.classList.remove('activated');
  });

  allTabContentImagesTargets.forEach((images) => {
    images.classList.add('hide');
    images.classList.remove('activated');
  });

  const targetContent = document.querySelector(`[data-tab-content-target="tab-content-${tabIndex}"]`);
  const targetImages = document.querySelector(`[data-tab-content-images-target="tab-content-images-${tabIndex}"]`);

  if (targetContent) {
    targetContent.classList.remove('hide');
    targetContent.classList.add('activated');
  }

  if (targetImages) {
    targetImages.classList.remove('hide');
    targetImages.classList.add('activated');
  }

  const allTabButtons = document.querySelectorAll('.inside_tab-button');
  allTabButtons.forEach((button) => {
    button.classList.remove('activated');
  });

  const targetButton = document.querySelector(`[data-tab-target="tab-${tabIndex}"]`);
  if (targetButton) {
    targetButton.classList.add('activated');
  }

  const plyrElements = targetContent.querySelectorAll('.plyr-video--load-later');

  plyrElements.forEach((video) => {
    video.play()
      .then(() => console.log("Video is now playing:", video))
      .catch((error) => console.error("Error playing video:", error));
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const allTabButtons = document.querySelectorAll('.inside_tab-button');
  allTabButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      const tabIndex = button.getAttribute('data-tab-target').split('-')[1];
      toggleBundleIngredients(tabIndex);
    });
  });
});




function handlePdpVideoPlayback() {
  const videoWrappers = document.querySelectorAll(".pdp-tab .plyr--video");

  videoWrappers.forEach(wrapper => {
    const video = wrapper.querySelector("video");
    if (!video) return;

    video.addEventListener("play", function () {
      videoWrappers.forEach(otherWrapper => {
        const otherVideo = otherWrapper.querySelector("video");
        if (otherVideo && otherVideo !== video && !otherVideo.paused) {
          otherVideo.pause();
        }
      });
    });
  });
}

document.addEventListener("DOMContentLoaded", handlePdpVideoPlayback);




//legacy

var selectors = {
  addToCart: '[data-add-to-cart]'
}

var tabs = [
  'product-description-',
  'product-howto-',
  'product-ingredients-'
];

theme.mfpInlineGallery = function () {
  $('.mfp-inline-gallery').magnificPopup({
    type: 'inline',
    midClick: true,
    removalDelay: 500,
    mainClass: 'mfp-with-zoom',
    gallery: {
      enabled: true
    },
    callbacks: {
      buildControls: function () {
        this.contentContainer.append(this.arrowLeft.add(this.arrowRight));
      }
    }
  });
};

window.players = [];

theme.loadTab = function (idx, ref) {
  var url = `/?section_id=${tabs[idx]}${productJSON.handle}`;
  var $tabDiv = $(`.tab-${idx + 1}__inner`);

  if ($.trim($tabDiv.html()).length) {
    $(ref).addClass('visible');
    return;
  }

  $.get(url, function (data) {
    $tabDiv.html(data);
    window.players.push(Plyr.setup(`.tab-${idx + 1}__inner .plyr-video`));
    theme.mfpInlineGallery();
    $(ref).addClass('visible');
  }).fail(function (error) {
    console.error(error);
  }, 'html');
};

theme.paginateTestimonials = function () {
  var paragraphsPerPage = 5;
  var currentPage = 1;
  var pagingControlsContainer = '.testimonials-pagination';
  var $paragraphs = $('.testimonial-box');
  var pagingContainerPath = '.the-testimonials';
  var numPages = function () {
    var numPages = 0;
    if ($paragraphs != null && paragraphsPerPage != null) {
      numPages = Math.ceil($paragraphs.length / paragraphsPerPage);
    }
    return numPages;
  };
  var renderControls = function (container, currentPage, numPages) {
    var pagingControls = '<ul>';
    for (var i = 1; i <= numPages; i++) {
      if (i != currentPage) {
        pagingControls += `<li><a class="testimonial-paginate" data-page="${i}" href="#">${i}</a></li>`;
      } else {
        pagingControls += `<li class="current-page"><span>${i}</span></li>`;
      }
    }
    pagingControls += '</ul>';
    $(container).html(pagingControls);
  }
  function showPage(page) {
    var page = page;
    currentPage = page;
    var html = '';
    $paragraphs.slice((page - 1) * paragraphsPerPage, ((page - 1) * paragraphsPerPage) + paragraphsPerPage).each(function () {
      html += '<div>' + $(this).html() + '</div>';
    });

    $(pagingContainerPath).html(html);
    renderControls(pagingControlsContainer, currentPage, numPages());
  }

  $(document).on('click', '.testimonial-paginate', function (e) {
    e.preventDefault();
    showPage(parseFloat($(this).data('page')));
    theme.scrollTo('.the-testimonials', 100);
  });

  showPage(1);
};

theme.getNumberOfPages = function (list, numberPerPage) {
  return Math.ceil(list.length / numberPerPage);
}
theme.nextPage = function () {
}


theme.blueCocoonFaqVideo = function () {
  if (productJSON.title != 'The Blue Cocoon') return;
  var embed = `<div class="video-wrapper"><iframe src="https://player.vimeo.com/video/515939375?color=906d4f&title=0&byline=0&portrait=0" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe></div>`;

  $('.faq-answer').eq(0).append(embed);

}

theme.tabControl = function (e) {
  var $el = $(e.target),
    $tab = $el.closest('.pdp-tab');

  if ($tab.length) {
    $(`a[href="#${$tab.attr('id')}"`).trigger('click');
  }
};
$(function () {

  $('.pdp-tab-content').each(function (i, tabContent) {
    var myHTML = $(this).html();
    if (theme.isMobile() || i > 2) {
      $(`.pdp-accordion .tab-${i + 1}__inner`).html(myHTML);
      $(`.pdp-accordion .tab-${i + 1}__inner video`).addClass('plyr-video--load-later');
      $(`.pdp-accordion .tab-${i + 1}__inner`).closest('.pdp-accordion__item').fadeIn();

    } else {
      $(`.pdp-tab .tab-${i + 1}__inner`).html(myHTML);
      $(`.pdp-tab .tab-${i + 1}__inner video`).addClass('plyr-video--load-later');
    }
    $(tabContent).empty();

  });
  theme.mfpInlineGallery();

  $('.plyr-video--load-later').each(function (i, v) {
    var myId = '#' + $(v).attr('id');
    if ($(myId).length == 0) return true;
    var newPlayer = Plyr.setup(myId);
    window.players.push(newPlayer[0]);
  });


  $('.pdp-tabs__heading').on('click', function (e) {
    e.preventDefault();
    var ref = $(this).attr('href');

    $('.pdp-tabs__heading').removeClass('active');
    $(this).addClass('active');

    $('.pdp-tab').hide();
    $(ref).fadeIn();

    if ($(this).attr('id') === 'tab2' || 'tab1') {
      var videoContainer = $(ref).find('.one-third');
      if (videoContainer.length && !videoContainer.is('[data-vertical-video]')) {
        var plyrId = videoContainer.find('video').attr('id');
        if (plyrId) {
          wick.playThisPlyr(plyrId);
        }
      }
    } else {
      var plyrId = $(ref).find('video').length
        ? $(ref).find('video').eq(0).attr('id')
        : $(ref).find('.plyr').eq(0).attr('id');
      if (plyrId) {
        wick.playThisPlyr(plyrId);
      }
    }

    return false;
  });

  $('.pdp-tabs__heading').eq(0).trigger('click');

  $('.pdp-accordion__heading > a').on('click', function () {
    const ref = $(this).attr('href');
    const accordionContent = $(ref);
    const oneThirdElement = accordionContent.find('.one-third');

    accordionContent.slideToggle('slow');
    $(this).closest('.pdp-accordion__item').toggleClass('active');

    if (ref === '#howto-accordion' && oneThirdElement.length && oneThirdElement.is('[data-vertical-video]')) {
    } else {
      const plyrId = accordionContent.find('video').length
        ? accordionContent.find('video').eq(0).attr('id')
        : accordionContent.find('.plyr').eq(0).attr('id');

      if (plyrId) {
        wick.playThisPlyr(plyrId);
      }
    }

    return false;
  });

  if (productJSON.handle == 'rise-ai-giftcard') {
    $('#product-description').insertAfter('.product-tagline');
  }

  $('.faq-question').on('click', function () {
    var $t = $(this);
    wick.stopAllVideos();
    $t.toggleClass('active').next().slideToggle('fast');
    if ($t.hasClass('active')) {
      var plyrId = $t.next().find('.plyr-video').attr('id');
      wick.playThisPlyr(plyrId);
    }
  });

  $(document).on("shopify:section:load", function (e) {
    theme.tabControl(e);
  });

  theme.paginateTestimonials();

  if ($('.the-testimonials').length == 0) {
    $('#testimonials-accordion').parent().hide();
  }

  if ($('#faq-accordion .faq-question').length == 0) {
    $('#faq-accordion').parent().hide();
  }

  theme.blueCocoonFaqVideo();

  if (productJSON.title == 'The Chocolate Box' && productJSON.available == true) {
    $('.more-infobtn').hide();
  }

  if ($(window).width() > 1024) {
    $('[data-zoom]').each(function (z, zoomItem) {
      $(zoomItem).zoom({ url: $(zoomItem).data('zoom-url') });
    });
  }

});

